
import customertagsinfo from '@/api/customer/customertagsinfo'
import customernursinginfo from '@/api/customer/customernursinginfo'
import customernursinglog from '@/api/customer/customernursinglog'












import tmh from './tmh/index'
import ispa from './ispa/index'


export default {
    tmh: tmh ,
    ispa : ispa,
    customer:{

        
        customertagsinfo:customertagsinfo,
        customernursinginfo:customernursinginfo,
        customernursinglog:customernursinglog,
        
    },
}


// WEBPACK FOOTER //
// ./src/api/index.js